import { render, staticRenderFns } from "./ReporterPage.vue?vue&type=template&id=be74f772&scoped=true&"
import script from "./ReporterPage.vue?vue&type=script&lang=js&"
export * from "./ReporterPage.vue?vue&type=script&lang=js&"
import style0 from "./ReporterPage.vue?vue&type=style&index=0&id=be74f772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be74f772",
  null
  
)

export default component.exports